export const flight = {
  next: {
    upcoming: true,
  },
  prev: {
    upcoming: false,
  },
};
